/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import { defineComponent, ref, onMounted, nextTick, createVNode } from 'vue';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { _ as _defineProperty } from '../../_chunks/dep-6e49aa22.mjs';
import { s as setStyle } from '../../_chunks/dep-b0b0fb5e.mjs';
import { d as getIEVersion } from '../../_chunks/dep-684f6096.mjs';
import '../../config-provider/hooks/useConfig.mjs';
import 'lodash-es';
import '../../config-provider/utils/context.mjs';
import '../../_chunks/dep-99da72b8.mjs';
import '../../_chunks/dep-6da93342.mjs';
import '../../_chunks/dep-b0ea6825.mjs';
import '../../_chunks/dep-2705c570.mjs';
import '../../_chunks/dep-bc824998.mjs';
import '../../config-provider/type.mjs';
import '../../_chunks/dep-35b16530.mjs';
import '../../_chunks/dep-d531a7f4.mjs';
import '../../_chunks/dep-11896cb9.mjs';
import '../../_chunks/dep-8d3c9348.mjs';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function circleAdapter(circleElem) {
  var _window, _window$getComputedSt2, _window2;
  var basicStyle = {};
  if (!circleElem || typeof window === "undefined") {
    return;
  }
  var _window$getComputedSt = (_window = window) === null || _window === void 0 || (_window$getComputedSt2 = _window.getComputedStyle) === null || _window$getComputedSt2 === void 0 ? void 0 : _window$getComputedSt2.call(_window, circleElem),
    color = _window$getComputedSt.color,
    fontSize = _window$getComputedSt.fontSize;
  var ua = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.navigator) === null || _window2 === void 0 ? void 0 : _window2.userAgent;
  var isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
  var isIosWechat = /(?=.*iPhone)[?=.*MicroMessenger]/.test(ua) && !/Chrome/.test(ua);
  if (isSafari || isIosWechat) {
    basicStyle = {
      transformOrigin: "0px 0px",
      transform: "scale(".concat(parseInt(fontSize, 10) / 12, ")")
    };
  }
  if (color && getIEVersion() > 11) {
    var matched = color.match(/[\d.]+/g);
    var endColor = matched ? "rgba(".concat(matched[0], ", ").concat(matched[1], ", ").concat(matched[2], ", 0)") : "";
    setStyle(circleElem, _objectSpread(_objectSpread({}, basicStyle), {}, {
      background: "conic-gradient(from 90deg at 50% 50%,".concat(endColor, " 0deg, ").concat(color, " 360deg)")
    }));
  } else {
    setStyle(circleElem, _objectSpread(_objectSpread({}, basicStyle), {}, {
      background: ""
    }));
  }
}

var GradientIcon = defineComponent({
  name: "TLoadingGradient",
  setup: function setup() {
    var classPrefix = usePrefixClass();
    var circleRef = ref();
    onMounted(function () {
      nextTick(function () {
        circleAdapter(circleRef.value);
      });
    });
    return function () {
      var name = "".concat(classPrefix.value, "-loading__gradient");
      var classes = [name, "".concat(classPrefix.value, "-icon-loading")];
      return createVNode("svg", {
        "class": classes,
        "viewBox": "0 0 12 12",
        "version": "1.1",
        "width": "1em",
        "height": "1em",
        "xmlns": "http://www.w3.org/2000/svg"
      }, [createVNode("foreignObject", {
        "x": "0",
        "y": "0",
        "width": "12",
        "height": "12"
      }, [createVNode("div", {
        "class": "".concat(name, "-conic"),
        "ref": circleRef
      }, null)])]);
    };
  }
});

export { GradientIcon as default };
//# sourceMappingURL=gradient.mjs.map
